module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside-menu px-4"
  }, [_c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-4"
  }, [_c('h6', [_c('b', [_vm._v("待办事项 1")]), _vm._v(" "), _c('i-switch', {
    staticClass: "float-right"
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("系统利用率")]), _vm._v(" "), _c('i-circle', {
    attrs: {
      "size": 200,
      "trail-width": 4,
      "stroke-width": 5,
      "percent": 75,
      "stroke-linecap": "square",
      "stroke-color": "#43a3fb"
    }
  }, [_c('div', {
    staticClass: "demo-i-circle-custom"
  }, [_c('h1', [_vm._v("42,001,776")]), _vm._v(" "), _c('p', [_vm._v("下载人数")]), _vm._v(" "), _c('span', [_vm._v("\n              占总访问人数\n              "), _c('i', [_vm._v("75%")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('Progress', {
    attrs: {
      "percent": 95,
      "stroke-width": 7,
      "status": "active"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('Progress', {
    attrs: {
      "percent": 95,
      "stroke-width": 7,
      "status": "wrong"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('Progress', {
    attrs: {
      "percent": 25,
      "stroke-width": 7,
      "status": "success"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("25GB/256GB")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("明天提醒我吃黄焖鸡")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-uppercase mb-1 mt-4"
  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-uppercase mb-1 mt-2"
  }, [_c('small', [_c('b', [_vm._v("SSD  Usage")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22b0f452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 1085
// module chunks = 284